import moduleStyles from './module.module.less'
import { message, Button, Col, ConfigProvider, Layout, Pagination, Row, Tabs, Input, Modal, Tooltip,} from 'antd'
import {FilePdfOutlined, SearchOutlined,PlusOutlined,GlobalOutlined,UserOutlined,PlayCircleOutlined} from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import zhCN from 'antd/lib/locale/zh_CN'
import Cookies from 'js-cookie'

import 'katex/dist/katex.min.css' // `rehype-katex` does not import the CSS for you


import Icon from '@ant-design/icons'
import  { ReactComponent as bookSvg }   from '../../static/image/module/book.svg'
import  { ReactComponent as editSvg }   from '../../static/image/module/edit.svg'
import { ReactComponent as eyeSvg }   from '../../static/image/module/eye.svg'
import { ReactComponent as deleteSvg }   from '../../static/image/module/delete.svg'
import { ReactComponent as clockSvg }   from '../../static/image/module/clocko.svg'
import { ReactComponent as checkSvg }   from '../../static/image/module/checksquare.svg'
import { ReactComponent as pencilSvg }   from '../../static/image/module/pencil.svg'
import { ReactComponent as expSvg }   from '../../static/image/module/experiment.svg'

import emptyExercise from '../../static/image/empty/queshengye-timu.png'
import { sendHttpPostRequest } from '../../api/http-request'
import Draggable from 'react-draggable'
import PublicTipModal from '@/component/PublicTipModal/PublicTipModal'
import GlobalCss from '@/global.module.less'


const bookIcon = (props:any) => (<Icon component={bookSvg} {...props} />)
const editIcon = (props:any) => (<Icon component={editSvg} {...props} />)
const eyeIcon = (props:any) => (<Icon component={eyeSvg} {...props} />)
const deleteIcon = (props:any) => (<Icon component={deleteSvg} {...props} />)
const clockIcon = (props:any) => (<Icon component={clockSvg} {...props} />)
const checkIcon = (props:any) => (<Icon component={checkSvg} {...props} />)
const pencilIcon = (props:any) => (<Icon component={pencilSvg} {...props} />)

const expIcon = (props:any) => (<Icon component={expSvg} {...props} />)



const { TabPane } = Tabs

export interface Props {}
export const ModuleList: React.FC<Props> = (props) => {
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数

  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const currentTag = useRef('') // 当前选中的tag

  const typeFilters = useRef([] as any[]) // 类型过滤选项
  const [isDeleteVisible, setIsDeleteVisible] = useState(false)
  const [loading, setLoading] = useState(false)

  const draggleRef = useRef<HTMLDivElement | null>(null)
  const [bounds, setBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [disabled, setDisabled] = useState(true)
  const querySource = useRef('2')
  const queryContent = useRef('') // 记录搜索串
  const page = useRef(1)
  const pageSize = useRef(9)
  const [moduleResult, setModuleResult] = useState([] as any[])

  const [deleteKnowledgeCellId, setDeleteKnowledgeCellId] = useState(
    null as any
  ) // 删除的知识点ID
  const [deleteKnowledgeCellName, setDeleteKnowledgeCellName] = useState(
    null as any
  ) // 删除的知识点名称

  const onStart = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }


  const newName = useRef('') // 名称
  const newDesc = useRef('') // 描述
  const [createModalVis, setCreateModalVis] = useState(false)
  const createOk = () => {
    const sessionid = Cookies.get('sessionid')
    let data = {
      name: newName.current,
      //description: newDesc.current,
      sessionid: sessionid,
      sid: sessionid,
    }
    sendHttpPostRequest('course/api/user_create_knowcell/', data, (res) => {
      if (res.is_ok == true) {
        message.success('新建知识点成功~')
        window.open(`/module-edit?module_id=${res.know_id}`);
        setCreateModalVis(false)
        queryModuleList(false)
      } else {
        message.error(res.message)
      }
    })
    newName.current = ''
    //newDesc.current = ''
    
  }

  const createCancel = () => {
    setCreateModalVis(false)
    newName.current = ''
    //newDesc.current = ''
  }


  useEffect(() => {
    queryModuleList(true)
  }, [])

  // 查知识点列表
  const queryModuleList = (firstTime) => {
    //setLoading(true)
    //setModuleResult([])
    //setResultSum(0)
    const _source = parseInt(querySource.current)
    let _params = {
      sessionid: Cookies.get('sessionid'),
      sid: Cookies.get('sessionid'),
      source: _source,
      is_my: _source,
      page: page.current,
      pagesize: pageSize.current,
      query: queryContent.current,
      tag: currentTag.current,
    }

    sendHttpPostRequest(
      'course/api/user_query_simple_knowcell_list',
      _params,
      (response: any) => {
        message.destroy()
        setLoading(false)
        if (response.code == -100) {
          // 未登录
          setModuleResult([])
          setResultSum(0)
          setTotalCount(0)
          //setMyTagList([])
          //setCourseNameList([])
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/oam_login?next=oam_exercise_list';
        } else if (response.code == 0) {
          // 成功
          setModuleResult(response.query_list)
          setResultSum(response.total_sum)
          setTotalCount(response.total_count)

          //console.log(firstTime == true)
          //firstTime == true ? setMyTagList(response.my_tag_list) : ''
          //firstTime == true ? setCourseNameList(response.course_name_list) : ''
        } else if (response.code == -501) {
          // 权限不足
          window.location.href = '/'
          // document.getElementById("show-login-modal")!.click();
          // window.location.href = '/oam_login?next=oam_exercise_list';
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 删除 知识点
  const deleteKnowledgeCell = () => {
    const totalPages = Math.ceil(resultSum / pageSize.current)
    const currentPage =
      resultSum % pageSize.current == 1 &&
      totalPages == page.current &&
      totalPages > 1
        ? page.current - 1
        : page.current
    // console.log(currentPage, totalPages);
    sendHttpPostRequest(
      'course/api/user_delete_knowcell_by_id',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        knowcell_id: deleteKnowledgeCellId,
      },
      (response: any) => {
        message.destroy()

        if (response.code == -100) {
          // 未登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/oam_login?next=oam_exercise_list';
        } else if (response.code == 0) {
          // 成功
          message.success('知识点删除成功')
          page.current = currentPage
          queryModuleList(false)
        } else if (response.code == -501) {
          // 权限不足
          // document.getElementById("show-login-modal")!.click();
          // window.location.href = '/oam_login?next=oam_exercise_list';
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 切换tab页
  const onTabsChange = (key: string) => {
    querySource.current = key
    page.current = 1
    currentTag.current = ''
    //setSelectedTags([0])
    queryModuleList(true)
  }

  //点击了搜索按钮
  const onSearchBtn = (event: any) => {
    page.current = 1
    queryContent.current = event.target.value
    queryModuleList(false)
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryModuleList(false)
  }

 
  return (
    <Layout style={{ minHeight: 750, backgroundColor: '#f9f9f9' }}>
      <div className={moduleStyles.maincontent}>
        <div
          className={moduleStyles.moduleList}
        >

          <div className={moduleStyles.mainTopDiv}>
              <div className={moduleStyles.mainTopTitle}>
                  知识点管理
              </div>

              <div className={moduleStyles.mainTopDesp}>
                  浏览和管理所有课程知识点
              </div>
          </div>

          <Row style={{ paddingRight: 24, marginBottom: 20 }}>
            <Col flex={"auto"}>
              <div>

                <Input
                  onPressEnter={onSearchBtn}
                  placeholder="请输入知识点名称或ID..."
                  className={moduleStyles.searchInput}
                  suffix={<SearchOutlined style={{ color: '#666666' }} />}
                />



              </div>
            </Col>

            <Col flex={"160px"} style={{textAlign:'right'}}>
              <div>
                <span
                  
                  className={moduleStyles.createBtn}
                  onClick={()=>{setCreateModalVis(true)}}
                >
                  <PlusOutlined /> 创建知识点
                </span>
                </div>
            </Col>
          </Row>


          <Tabs
            defaultActiveKey="2"
            size="small"
            style={{ paddingRight:24}}
            onChange={onTabsChange}
          >
            <TabPane tab={<div><GlobalOutlined /> 平台</div>} key="2">
              <div className={moduleStyles.moduleListWarpper}>
              <Row gutter={[36, 36]} justify="start" wrap={true}>
                    {moduleResult?.map((module, index) => {
                      return (

                        <Col span={8}  key={module.id}>
                          <div className={moduleStyles.moduleCardDiv}>
                            <Row wrap={false} align={"middle"} style={{marginBottom:12}}>
                              <Col span={8} style={{textAlign:'left'}}>
                              <div>
                              <span className={moduleStyles.moduleTypeLabel} style={module.type == 2?  {color:'rgb(37 99 235)', background:'rgb(239 246 255)'}: {color:'rgb(139 92 246)', background:'rgb(245 243 255)'} }>
                                {module.type == 2? <><PlayCircleOutlined /> 视频</> : <> <FilePdfOutlined /> PDF</>}
                              </span>
                              </div>
                              </Col>

                              <Col span={16} style={{textAlign:'right'}}>
                                    <div className={moduleStyles.moduleCardTime}>
                                       创建于 {module?.create_time}
                                    </div>
                                  </Col>

                            </Row>

                            <div className={moduleStyles.moduleTitle}>
                                {module.name}
                            </div>

                            <div className={moduleStyles.moduleCardContentItem}>
                                  <span className={moduleStyles.moduleCardContentIconWrapper}>
                                     {module.type == 2? <Icon component={clockIcon}/> : <Icon component={bookIcon}/>} 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                      {module.type == 2? <>时长: {module?.video_duration}</> :  <>页数: {module.lecture_pages}页</> }
                                  </span>
                            </div>

                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0 0'}}>
                                <span className={moduleStyles.moduleCardContentIconWrapper}>
                                      <Icon component={pencilIcon}/> 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                    练习题: {module?.practice_count}道
                                  </span>
                            </div>



                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0 0'}}>
                                 <span className={moduleStyles.moduleCardContentIconWrapper}>
                                      <Icon component={checkIcon}/> 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                  作业考试题: {module?.exam_count}道
                                  </span>

                            </div>


                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0'}}>
                                 { module?.case_id !== -1 && <span className={moduleStyles.moduleCardContentIconWrapper}>
                                     <Icon component={expIcon}/>  
                                  </span> 
                                  }

                                  <span style={{marginLeft:8}} className={moduleStyles.moduleCardExpSpan} 
                                    onClick={()=>{ module?.case_id? window.open(`/case-detail?case_id=${module?.case_id}`) :''}}
                                  >
                                    {module?.case_name}
                                  </span>

                            </div>

                    
                            <Row wrap={false} align={'middle'} className={moduleStyles.moduleCardBottomDiv}>

                              <Col flex="80px" style={{textAlign:'left'}}>
                                <div style={{color:'#9ca3af', fontSize:12}}>
                                  {module?.view_count}人学习
                                </div>
                              </Col>

                              <Col flex="auto" style={{textAlign:'right'}}>

                                <div>
                                    <span 
                                      className={moduleStyles.lookBtn}
                                      onClick={()=>{window.open(`/module-learn-preview?module_id=${module.id}`)}}
                                    >

                                      <Icon component={eyeIcon}/>   查看
                                      
                                    </span>
                                </div>
                              </Col>
                            </Row>
                           

                          </div>
                        </Col>

                      )
                    })}
                  </Row>
              </div>
            </TabPane>

            <TabPane tab={<div><UserOutlined /> 我的</div>} key="1">
              {moduleResult?.length != 0 && (
                <div className={moduleStyles.moduleListWarpper}>

                  <Row gutter={[36, 36]} justify="start" wrap={true}>
                    {moduleResult?.map((module, index) => {
                      return (

                        <Col span={8}  key={module.id}>
                          <div className={moduleStyles.moduleCardDiv}>
                            <Row wrap={false} align={"middle"} style={{marginBottom:12}}>
                              <Col span={8} style={{textAlign:'left'}}>
                              <div>
                              <span className={moduleStyles.moduleTypeLabel} style={module.type == 2?  {color:'rgb(37 99 235)', background:'rgb(239 246 255)'}: {color:'rgb(139 92 246)', background:'rgb(245 243 255)'} }>
                                {module.type == 2? <><PlayCircleOutlined /> 视频</> : <> <FilePdfOutlined /> PDF</>}
                              </span>
                              </div>
                              </Col>

                              <Col span={16} style={{textAlign:'right'}}>
                                    <div className={moduleStyles.moduleCardTime}>
                                       创建于 {module?.create_time}
                                    </div>
                                  </Col>

                            </Row>

                            <div className={moduleStyles.moduleTitle}>
                                {module.name}
                            </div>

                            <div className={moduleStyles.moduleCardContentItem}>
                                  <span className={moduleStyles.moduleCardContentIconWrapper}>
                                     {module.type == 2? <Icon component={clockIcon}/> : <Icon component={bookIcon}/>} 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                      {module.type == 2? <>时长: {module?.video_duration}</> :  <>页数: {module.lecture_pages}页</> }
                                  </span>
                            </div>

                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0 0'}}>
                                <span className={moduleStyles.moduleCardContentIconWrapper}>
                                      <Icon component={pencilIcon}/> 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                    练习题: {module?.practice_count}道
                                  </span>
                            </div>

                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0  0'}}>
                                 <span className={moduleStyles.moduleCardContentIconWrapper}>
                                      <Icon component={checkIcon}/> 
                                  </span> 

                                  <span style={{marginLeft:8}}>
                                  作业考试题: {module?.exam_count}道
                                  </span>

                            </div>

                            <div className={moduleStyles.moduleCardContentItem} style={{margin:'12px 0'}}>
                                { module?.case_id !== -1 && <span className={moduleStyles.moduleCardContentIconWrapper}>
                                          <Icon component={expIcon}/>  
                                      </span> 
                                  }

                                  <span style={{marginLeft:8}} className={moduleStyles.moduleCardExpSpan} 
                                    onClick={()=>{ module?.case_id? window.open(`/case-detail?case_id=${module?.case_id}`) :''}}
                                  >
                                    {module?.case_name}
                                  </span>

                            </div>

                    
                            <Row wrap={false} align={'middle'} className={moduleStyles.moduleCardBottomDiv}>

                              <Col flex="80px" style={{textAlign:'left'}}>
                                <div style={{color:'#9ca3af', fontSize:12}}>
                                  {module?.view_count}人学习
                                </div>
                              </Col>

                              <Col flex="auto" style={{textAlign:'right'}}>

                                <div>
                                    <span

                                      className={moduleStyles.deleteBtn}
                                      onClick={() => {
                                        setDeleteKnowledgeCellId(module.id)
                                        setDeleteKnowledgeCellName(module.name)
                                        setIsDeleteVisible(true)
                                      }}
                                    >
                                      <Icon component={deleteIcon}/>  删除
                                    </span>

                                    <span
                                      className={moduleStyles.editBtn}
                                      onClick={()=>{window.open(`/module-edit?module_id=${module.id}`)}}
                                    >
                                      
                                      <Icon component={editIcon}/>  编辑
                                      
                                    </span>

                                    <span 
                                      className={moduleStyles.lookBtn}
                                      onClick={()=>{window.open(`/module-learn-preview?module_id=${module.id}`)}}
                                    >

                                      <Icon component={eyeIcon}/>   查看
                                      
                                    </span>
                                </div>
                              </Col>
                            </Row>
                           

                          </div>
                        </Col>

                      )
                    })}
                  </Row>
                </div>
              )}

              {moduleResult?.length == 0 && (
                <div hidden={loading}>
                  <img src={emptyExercise} height={150} />
                  <div style={{ color: '#999999' }}>您还没有创建知识点哟~</div>
                  <Button
                    size="small"
                    style={{
                      border: '1px solid #07c176',
                      color: '#07c176',
                      marginTop: 10,
                      borderRadius: 3,
                    }}
                    type="default"
                    onClick={()=>{setCreateModalVis(true)}}
                  >
                    {' '}
                    立即创建
                  </Button>
                </div>
              )}
            </TabPane>
          </Tabs>

          <ConfigProvider locale={zhCN}>
            <div  style={{ marginBottom: 30, paddingTop: 36 }}
                  className={'css.pagination'} >
              <Pagination
                defaultCurrent={1}
                current={page.current}
                total={resultSum}
                defaultPageSize={9}
                hideOnSinglePage={true}
                onChange={onPageChange}
                showSizeChanger={false}
              />
            </div>
          </ConfigProvider>

          <Modal
            title={
              <div
                style={{ width: '100%', cursor: 'move' }}
                onMouseOver={() => {}}
                onMouseOut={() => {}}
                onFocus={() => {}}
                onBlur={() => {}}
              >
                提示
              </div>
            }
            width={350}
            closable={false}
            open={isDeleteVisible}
            className={moduleStyles.miniModal}
            footer={
              <div>
                <Button
                  className={moduleStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#07c160' }}
                  onClick={() => {
                    setIsDeleteVisible(false)
                  }}
                >
                  取消
                </Button>
                <Button
                  className={moduleStyles.stepsBtn}
                  style={{ marginRight: 20, color: '#fff' }}
                  type="primary"
                  onClick={() => {
                    setIsDeleteVisible(false)
                    deleteKnowledgeCell()
                  }}
                >
                  确认
                </Button>
              </div>
            }
            modalRender={(modal) => (
              <div>
                <Draggable
                  disabled={disabled}
                  bounds={bounds}
                  onStart={(event, uiData) => onStart(event, uiData)}
                >
                  <div ref={draggleRef}>{modal}</div>
                </Draggable>{' '}
              </div>
            )}
          >
            <div style={{ width: 250, margin: '0 auto', textAlign: 'center' }}>
              确认删除知识点
              <span style={{ color: '#07c160', margin: 4 }}>
                {deleteKnowledgeCellId}-{deleteKnowledgeCellName}
              </span>
              吗？ 删除后不可恢复。
            </div>
          </Modal>
        </div>
      </div>


      <PublicTipModal
        modalContent={<div>
            <Row align={'middle'} justify={'start'} className={GlobalCss.formRow}>
            <Col className={GlobalCss.requiredLabel}>名称</Col>
            <Col>
            <Input
                style={{
                width: '300px',
                }}
                placeholder="请输入知识点名称"
                maxLength={50}
                onChange={(e) => {
                newName.current = e.target.value
                }}
            />
            </Col>
        </Row>
        {/*<Row align={'top'} justify={'start'} className={GlobalCss.formRow} style={{marginTop:15}}>
            <Col className={GlobalCss.requiredLabel}>描述</Col>
            <Col>
            <Input.TextArea
                style={{
                minHeight: '145px',
                width: '300px',
                }}
                placeholder="请输入知识点描述"
                onChange={(e) => {newDesc.current = e.target.value}}
            />
            </Col>
        </Row>*/}
        </div>
        }
        modalTitle={'创建知识点'}
        handleOk={createOk}
        handleCancel={createCancel}
        open={createModalVis}
        setOpen={setCreateModalVis}
    />

    </Layout>
  )
}

export default ModuleList
